// Labels for the recipients block, in the builder and anywhere that mirrors it
// (the "Save as Preset" audience checkbox). The choice is driven by the base
// campaign type: recurring and join/enrollment campaigns target Group(s), plain
// message campaigns target Recipient(s). Surveys and polls inherit the label of
// whatever base type they are built on — a join-based survey targets groups, a
// message-based one targets recipients — so they need no case of their own.
//
// The rule itself lives in the policies: `recurringSpec` pins Group(s) and
// ignores any config label, `inboundRecipients` and the `makePolicy` default
// let `config.recipients.label` win first.
export const GROUP_AUDIENCE_LABEL = 'Group(s)';
export const RECIPIENT_AUDIENCE_LABEL = 'Recipient(s)';
